import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { OffshoreLevel } from '../../../core/models/offshore-level';
import { OffshoreLevelService } from '../../../core/services/offshore-level.service';
import { TagModule } from 'primeng/tag';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddOffshoreLevelComponent } from './add-offshore-level/add-offshore-level.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { EmPermissionDirective } from '../../../shared/directives/has-permission.directive';
import { Permission } from '../../../core/enums/permission.enum';


@Component({
  selector: 'em-offshore-level',
  standalone: true,
  imports: [CommonModule, TableModule, ButtonModule, ToastModule, ConfirmDialogModule, TagModule, TranslatePipe,EmPermissionDirective],
  templateUrl: './offshore-level.component.html',
  styleUrl: './offshore-level.component.scss',
  providers: [ConfirmationService],
})
export class OffshoreLevelComponent {
  offshoreLevels!: OffshoreLevel[];

  ref: DynamicDialogRef | undefined;
  translations: any = {};
  Permission = Permission;
  selectedOffshoreLevel!: OffshoreLevel | null;
  displayViewDialog: boolean = false;

  constructor(
    private offshoreLevelService: OffshoreLevelService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialogService: DialogService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.getAllOffshoreLevels();
    this.loadTranslations();
  }

  loadTranslations() {
    this.translate
      .get([
        'layout.configurations.offshoreLevel.addOffshoreLevel.title',
        'layout.configurations.offshoreLevel.viewOffshoreLevel.title',
        'layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.detail',
        'layout.configurations.offshoreLevel.editOffshoreLevel.title',
        'layout.configurations.offshoreLevel.editOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.successMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.successMessage.detail',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.message',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.yes',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.no',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.detail',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.title',
        'layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.detail',
        'layout.configurations.offshoreLevel.editOffshoreLevel.successMessage.detail',
        'layout.configurations.offshoreLevel.yes',
        'layout.configurations.offshoreLevel.no',

      ])
      .subscribe((translations) => {
        this.translations = translations;
      });
  }

  getTranslatedValue(countsAsOffshore: boolean): string {
    return countsAsOffshore
      ? this.translations['layout.configurations.offshoreLevel.yes']
      : this.translations['layout.configurations.offshoreLevel.no'];
  }

  getAllOffshoreLevels() {
    this.offshoreLevelService.getAllOffshoreLevels().subscribe((data) => (this.offshoreLevels = data));
  }

  onAdd() {
    this.ref = this.dialogService.open(AddOffshoreLevelComponent, {
      header: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.title'],
      width: '500px',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });

    this.ref.onClose.subscribe((result) => {
      if (!result) return;
      if (result.type === 'created') {
        this.getAllOffshoreLevels();
        this.messageService.add({
          key: 'main',
          severity: 'success',
          summary: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.title'],
          detail: this.translations['layout.configurations.offshoreLevel.addOffshoreLevel.successMessage.detail'],
        });
      }
    });
  }

  onView(offshoreLevel: OffshoreLevel) {
    this.selectedOffshoreLevel = offshoreLevel;
    this.displayViewDialog = true;
    this.ref = this.dialogService.open(AddOffshoreLevelComponent, {
      header: this.translations['layout.configurations.offshoreLevel.viewOffshoreLevel.title'],
      width: '320px',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        mode: 'view',
        offshoreLevel: offshoreLevel
      }
    });
    this.ref.onClose.subscribe((result) => {
    if (!result) return;});
  }

  onEdit(offshoreLevel: OffshoreLevel) {
    this.ref = this.dialogService.open(AddOffshoreLevelComponent, {
      header: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.title'],
      width: '320px',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
       data: {
       mode: 'edit',
        offshoreLevel: offshoreLevel
       }
    });

    this.ref.onClose.subscribe((result) => {
    if (!result) return;

    if (result.type === 'updated') {
      this.getAllOffshoreLevels();
         this.messageService.add({
            key: 'main',
            severity: 'success',
            summary: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.successMessage.title'],
            detail: this.translations['layout.configurations.offshoreLevel.editOffshoreLevel.successMessage.detail'],
          });
    }
  else if (result.type === 'no-change') {
      this.messageService.add({
        key: 'main',
        severity: 'warn',
        summary: this.translate.instant('layout.configurations.users.assignRolesToUser.roles.noChanges'),
        detail: this.translate.instant('layout.configurations.users.assignRolesToUser.roles.noUpdateMessage'),
      });
    }}
  
  );
  }

  onDelete(event: Event, id: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.message'],
      icon: 'pi pi-info-circle',
      header: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.title'],
      acceptIcon: 'none',
      rejectIcon: 'none',
      acceptLabel: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.yes'],
      rejectLabel: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.no'],
      acceptButtonStyleClass: 'p-button-danger',
      accept: () => {
        this.deleteOffshoreLevel(id);
      },
      reject: () => {
        this.messageService.add({
          key: 'main',
          severity: 'info',
          summary: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.title'],
          detail: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.infoMessage.detail'],
          life: 3000,
        });
      },
    });
  }

  deleteOffshoreLevel(id: number) {
    this.offshoreLevelService.deleteOffshoreLevel(id).subscribe({
      next: () => {
        this.getAllOffshoreLevels();
        this.messageService.add({
          key: 'main',
          severity: 'success',
          summary: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.successMessage.title'],
          detail: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.successMessage.detail'],
        });
      },
      error: (err) => {
        console.log('Error deleting offshore level: ' + err);
        this.messageService.add({
          key: 'main',
          severity: 'error',
          summary: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.title'],
          detail: this.translations['layout.configurations.offshoreLevel.deleteOffshoreLevel.errorMessage.detail'],
        });
      },
    });
  }
  truncate(value: string | null | undefined, limit: number = 20): string {
    if (!value) return '';
     return value.length > limit ? value.substring(0, limit) + '...' : value;
  }
}
